const defaultState = {
	plants: [],
	searchParams: {
		plantCd: '',
		msgLang: 'ko_KR',
		groupId: null,
		screenId: null,
		scrUrl: null
	},
	groups: [],
	menuTree: [],
	groupScreenFuncList: [],
	commFuncList: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
